// ------------------------------------------
// SideButtons component (unchanged)

import { ChevronDown, ChevronUp, Trash } from "lucide-react";

// ------------------------------------------
type SideButtonsProps = {
   stageIndex?: number;
   optionIndex?: number;
   itemIndex?: number;
   type: "item" | "option" | "stage";
   moveUp: (
      type: "item" | "option" | "stage",
      stageIndex: number | undefined,
      optionIndex: number | undefined,
      itemIndex: number | undefined
   ) => void;
   moveDown: (
      type: "item" | "option" | "stage",
      stageIndex: number | undefined,
      optionIndex: number | undefined,
      itemIndex: number | undefined
   ) => void;
   remove: (
      type: "item" | "option" | "stage",
      stageIndex: number | undefined,
      optionIndex: number | undefined,
      itemIndex: number | undefined
   ) => void;
};

export const SideButtons = ({
   stageIndex,
   optionIndex,
   itemIndex,
   moveDown,
   moveUp,
   remove,
   type,
}: SideButtonsProps) => {
   return (
      <div className="absolute right-2 flex items-center space-x-2 opacity-0 transition-opacity duration-200 group-hover:opacity-100">
         <button
            onClick={(e) => {
               e.stopPropagation();
               moveUp(type, stageIndex, optionIndex, itemIndex);
            }}
            className="text-gray-500 hover:text-gray-700"
         >
            <ChevronUp size={16} />
         </button>
         <button
            onClick={(e) => {
               e.stopPropagation();
               moveDown(type, stageIndex, optionIndex, itemIndex);
            }}
            className="text-gray-500 hover:text-gray-700"
         >
            <ChevronDown size={16} />
         </button>
         <button
            onClick={(e) => {
               e.stopPropagation();
               remove(type, stageIndex, optionIndex, itemIndex);
            }}
            className="text-red-500 hover:text-red-700"
         >
            <Trash size={16} />
         </button>
      </div>
   );
};
